import React, { useState, useCallback } from 'react';
import styles from './Sidebar.module.css';
import Imagenes from '../../../images/logoturismo.png';
import SolicitudLogo from '../../../images/crearsolicitud.png';
import Logossoli from '../../../images/21.png';
import cambiologo from '../../../images/32.png';
import Logofflogo from '../../../images/cierresesion.png';
import { logout } from '../../../redux/actions/auth';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { resetSolicitud } from '../../../redux/actions/solicitud';

const Sidebar = ({ logout, open, setOpen, showToggle }) => {
    const dispatch = useDispatch();
    const [redirect, setRedirect] = useState(false);
    const logoutHandler = () => {
        logout()
        setRedirect(true);
    }
    if (redirect) {
        window.location.reload(false);
        window.location.href = '/';
    }

    const handleCreateSolicitud = useCallback((e) => {
        dispatch(resetSolicitud());
    }, [dispatch]);

    // El fondo oscuro cubre toda la pantalla: un clic fuera del panel (o en un enlace) lo cierra
    const handleSidebarClick = () => {
        setOpen(!open); // Invierte el valor actual de open
    };

    return (

        <>
            {open ? (
                <div className={styles.backdrop} onClick={handleSidebarClick}>
                    <div className={styles.panel}>
                        <img className={styles.logo} src={Imagenes} alt="DUOC ECOTURISMO" />
                        <hr />
                        <div className={styles.columns}>
                            <ul className={styles.list}>
                                <Link className={styles.item} to='/request' onClick={handleCreateSolicitud}>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={SolicitudLogo} alt="" />
                                        <p className={styles.itemText}>Crear Solicitud</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/landing'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logossoli} alt="" />
                                        <p className={styles.itemText}>Solicitudes</p> 
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/CambioContrasena'>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={cambiologo} alt="" />
                                        <p className={styles.itemText}>Cambio de contraseña</p>
                                        </div>
                                </Link>
                                <Link className={styles.item} to='/' onClick={logoutHandler}>
                                <div className={styles.itemLink} >
                                        <img className={styles.itemIcon} src={Logofflogo} alt="" />
                                        <p className={styles.itemText}>Cerrar sesión</p>
                                        </div>
                                </Link>
                            </ul>

                        </div>
                    </div>
                </div>
            ) : showToggle && (<button onClick={handleSidebarClick} className={styles.toggle}>
            ❯
        </button>)}
        </>
    );
};

export default connect(null, {
    logout
})(Sidebar);
